import { useTranslation } from 'react-i18next';
import { activityFeed } from '@/mocks/dashboard';

export default function ActivityFeed() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 rounded-xl border border-background-200 overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-100">
            <i className="ri-pulse-line text-foreground-600 text-sm" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-foreground-900 text-sm">{t('dashboard.activityFeed')}</h3>
            <p className="text-xs text-foreground-400 font-label">{t('dashboard.livePlatformEvents')}</p>
          </div>
        </div>
        <button className="text-xs text-accent-600 hover:text-accent-700 font-label font-medium cursor-pointer whitespace-nowrap">
          {t('common.viewAll')}
        </button>
      </div>

      {/* Items */}
      <div className="divide-y divide-background-100">
        {activityFeed.map((item) => (
          <div key={item.id} className="flex items-start gap-3 px-5 py-3.5 hover:bg-background-50/80 transition-colors">
            {/* Avatar */}
            <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 text-background-50 text-xs font-heading font-700 ${item.avatarBg}`}>
              {item.avatar}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground-700 font-label leading-snug">
                <span className="font-medium text-foreground-900">{item.user}</span>
                {' '}{item.action}{' '}
                <span className="font-medium text-accent-700">{item.subject}</span>
              </p>
              <div className="flex items-center gap-2 mt-1">
                <div className={`w-4 h-4 flex items-center justify-center rounded ${item.iconBg}`}>
                  <i className={`${item.icon} text-[10px] ${item.iconColor}`} />
                </div>
                <span className="text-xs text-foreground-400 font-label">{item.time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}